module.exports = __webpack_public_path__ + "static/media/paySucc_bg.a85c52a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/paySucc_bg.png
// module id = 1832
// module chunks = 0 1